<div class="AMTsaBlockerModal bg-am-medium-blue text-am-white">
  <div class="AMTsaBlockerModal-header">
    <img src="assets/images/close.svg" alt="close" (click)="onClose()">
  </div>
  <div class="AMTsaBlockerModal-content">
    <!-- <img src="./assets/images/information/chair.svg" alt="boardin passes" class="size-img"> -->
    <p class="title">{{ 'errorMsj.tsa_validation.header' | translate }}</p>
    <p class="subTitle">{{'errorMsj.tsa_validation.message' | translate: {regionsDesc: this.regions, terminal: this.terminal} }}</p>
  </div>
  <div class="AMTsaBlockerModal-footer">
    <button class="button-primary-amx" (click)="onClose()">{{'footer.continue' | translate }}</button>
  </div>
</div>
